const buttons = document.querySelectorAll<HTMLButtonElement>("#amb-application button:not(#_form_34_submit)");

buttons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const target = e.target as HTMLButtonElement;
    
    // can't simply hide the element or the video keeps playing and you can't stop it.
    const questionContainer = target.parentNode?.parentNode as HTMLElement | null;

    if (questionContainer && questionContainer.parentElement) {
      questionContainer.parentElement.removeChild(questionContainer);
    }

    const elementToShow = document.querySelector<HTMLElement>("#" + target.dataset.show);
    if (elementToShow) {
      elementToShow.classList.remove("hidden");
    }
  
    
  });
});
